export default __webpack_public_path__ + "static/media/bg-4.1fe97e03.jpg";